(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-sticky-variant"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__srStickyVariant) return;
    window.__srStickyVariant = true;

    document.addEventListener('change', function (event) {
      var select = event.target;
      if (!select || !select.matches || !select.matches('[data-sr-sticky-select]')) return;

      var option = select.options[select.selectedIndex];
      var label = select.closest('.sr-sticky-variant').querySelector('[data-sr-sticky-label]');
      if (label && option) label.textContent = option.getAttribute('data-label');

      var scope = select.closest('.shopify-section') || document;
      var input = scope.querySelector('variant-picker input[data-variant-id="' + select.value + '"]');
      if (!input) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.location.href = url.toString();
        return;
      }
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
